import { useEffect } from "react";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// Lightweight client-side SEO: updates route metadata without leaking homepage keywords.
export default function useSeo({ title, description, keywords, image, imageAlt, imageWidth, imageHeight } = {}) {
  useEffect(() => {
    // Always canonicalize to the www production host for consistent signals,
    // regardless of the host the page is currently served from.
    const url = "https://www.kapatia.com" + window.location.pathname;
    if (title) {
      document.title = title;
      setMeta("property", "og:title", title);
      setMeta("name", "twitter:title", title);
    }
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }
    if (keywords) setMeta("name", "keywords", keywords);
    else document.head.querySelector('meta[name="keywords"]')?.remove();
    if (image) {
      const imageUrl = new URL(image, window.location.origin).href;
      setMeta("property", "og:image", imageUrl);
      setMeta("name", "twitter:image", imageUrl);
      if (imageAlt) {
        setMeta("property", "og:image:alt", imageAlt);
        setMeta("name", "twitter:image:alt", imageAlt);
      }
      if (imageWidth) setMeta("property", "og:image:width", imageWidth);
      if (imageHeight) setMeta("property", "og:image:height", imageHeight);
    }
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", "Kapatia Pvt Ltd");
    setMeta("property", "og:url", url);
    setMeta("name", "twitter:card", "summary_large_image");
    setCanonical(url);
    return () => {
      const tag = document.head.querySelector('meta[name="keywords"]');
      if (keywords && tag?.getAttribute("content") === keywords) tag.remove();
    };
  }, [title, description, keywords, image, imageAlt, imageWidth, imageHeight]);
}
